// Data for Artwork component
const artwork_data = {
  en: {
    title: "Explore Artwork",
    subtitle:
      "Artwork that inspires, created by exceptional kids in the most adverse situations",
    featured_artwork_ids: [0, 1, 2],
    collection: [
      {
        artwork_heading: "Untethered Bond",
        artwork_subtitle:
          "An unbreakable bond between a mother and her child depicted through the use of vibrant colors",
        artwork_desc: [
          "Introducing 'Untethered Bond' a mesmerizing portrayal of an unbreakable connection between a mother and her child. Vibrant colors breathe life into this captivating artwork, evoking the profound essence of an inseparable bond.",
        ],
        artwork_artist: "by Nidhi, 10 years old, from India",
        artwork_more_from_artist: "more from Nidhi",
        artwork_image: "/assets/images/artworks/fox_art.jpg",
        artwork_artist_id: "0",
        artwork_art_id: "0",
        ngo_id: "1",
        category: "Drawing",
      },
      {
        artwork_heading: "Colors of Life",
        artwork_subtitle:
          "A depiction of the colors of life and the beauty of nature",
        artwork_desc: [
          "A stunning portrait of a cat rendered in a symphony of vibrant tones, revealing the diverse hues that paint the tapestry of existence.",
          "Gaze into the captivating eyes of this feline muse as it embodies the myriad colors that enrich our journey through life, creating an enchanting and harmonious visual symphony. Let the artwork whisk you away into a realm of color and contemplation, where the essence of life is beautifully captured through this mesmerizing depiction.",
        ],
        artwork_artist: "by Samuel, 14 years old, from Syria",
        artwork_more_from_artist: "more from Samuel",
        artwork_image: "/assets/images/artworks/cat_art.jpg",
        artwork_artist_id: "1",
        artwork_art_id: "1",
        ngo_id: "0",
        category: "Painting",
      },
      {
        artwork_heading: "Hands of Love",
        artwork_subtitle:
          "Hope and love can help you overcome any obstacle in life",
        artwork_desc: [
          "In this moving portrayal, delicate hands gracefully intertwine, symbolizing the unbreakable bonds formed by genuine affection and encouragement. The meticulous brushstrokes and meticulous attention to detail emphasize the significance of every connection we forge, whether with our loved ones or the world around us.",
          '"Hands of Love" is more than just a work of art; it is a testament to the indomitable spirit within us all. Allow yourself to be captivated by its profound symbolism and tender beauty, and let its message echo in your heart, inspiring you to embrace the power of hope and love in your own journey.',
        ],
        artwork_artist: "by Hamid, 12 years old, from Afghanistan",
        artwork_more_from_artist: "more from Hamid",
        artwork_image: "/assets/images/artworks/hands_art.jpg",
        artwork_artist_id: "2",
        artwork_art_id: "2",
        ngo_id: "2",
        category: "Painting",
      },
      {
        artwork_heading: "Blues of the Sky",
        artwork_subtitle: "Hope, Ambition, and Dreams",
        artwork_desc: [
          'Dive into the enchanting "Blues of the Sky," where hope, ambition, and dreams soar amidst a celestial canvas. This captivating artwork weaves a tapestry of aspirations, painted with ethereal blues that ignite the imagination and stir the soul.',
          "Lose yourself in the boundless expanse of possibilities, as this sublime piece beckons you to embrace the infinite potential that lies within your heart.",
        ],
        artwork_artist: "by Aarav, 10 years old, from Iran",
        artwork_more_from_artist: "more from Aarav",
        artwork_image: "/assets/images/artworks/abstract_1.webp",
        artwork_artist_id: "3",
        artwork_art_id: "3",
        ngo_id: "1",
        category: "Abstract",
      },
      {
        artwork_heading: "Silence of the Mountains",
        artwork_subtitle: "Nestled in the lap of nature",
        artwork_desc: [
          "A stunning portrayal of a mountain landscape, nestled in the lap of nature. The artist has used a variety of colors to depict the beauty of the mountains, and the serenity of the surrounding nature.",
          "Experience a serene masterpiece nestled in the lap of nature. Let the tranquil beauty of this artwork envelop you as you journey through the majestic peaks, embracing the profound stillness that echoes within the soul.",
        ],
        artwork_artist: "by Sara, 8 years old, from Syria",
        artwork_more_from_artist: "more from Sara",
        artwork_image: "/assets/images/artworks/mountain_art.jpg",
        artwork_artist_id: "4",
        artwork_art_id: "4",
        ngo_id: "0",
        category: "Contemporary",
      },
      {
        artwork_heading: "Monster Graffiti",
        artwork_subtitle: "A graffiti full of colorful monsters",
        artwork_desc: [
          "Experience an explosion of color and creativity! Unleash your imagination in this captivating graffiti artwork, where a vibrant world of delightful surprises awaits.",
          "Explore the depths of this imaginative creation, where every stroke of the artist's brush reveals a new and delightful monster waiting to be discovered.",
        ],
        artwork_artist: "by Samuel, 14 years old, from Syria",
        artwork_more_from_artist: "more from Samuel",
        artwork_image: "/assets/images/artworks/graffiti.jpg",
        artwork_artist_id: "1",
        artwork_art_id: "5",
        ngo_id: "0",
        category: "Other",
      },
      {
        artwork_heading: "Cloud of Thoughts",
        artwork_subtitle: "A depiction of the artist's thoughts",
        artwork_desc: [
          "Step into an introspective masterpiece that bares the artist's innermost musings. Unveil the enigmatic world of imagination and emotion, where strokes of brilliance converge to create a mesmerizing tapestry of thoughts.",
        ],
        artwork_artist: "by Hamid, 12 years old, from Afghanistan",
        artwork_more_from_artist: "more from Hamid",
        artwork_image: "/assets/images/artworks/oil_painting.webp",
        artwork_artist_id: "2",
        artwork_art_id: "6",
        ngo_id: "2",
        category: "Painting",
      },
      {
        artwork_heading: "Togetherness",
        artwork_subtitle:
          "Depicting the importance of togetherness through birds",
        artwork_desc: [
          "Experience the profound essence of 'Togetherness' a captivating artwork that beautifully captures the significance of unity through graceful birds in flight. Embark on a visual journey that celebrates the power of companionship, soaring high with the harmonious spirit of togetherness.",
        ],
        artwork_artist: "by Nidhi, 10 years old, from India",
        artwork_more_from_artist: "more from Nidhi",
        artwork_image: "/assets/images/artworks/birds.jpg",
        artwork_artist_id: "0",
        artwork_art_id: "7",
        ngo_id: "1",
        category: "Contemporary",
      },
      {
        artwork_heading: "Automobiles of the Past",
        artwork_subtitle: "Revisiting vehicles of the past",
        artwork_desc: [
          "Step into a nostalgic time capsule with 'Automobiles of the Past,' where the artistry of yesteryears' vehicles comes roaring back to life.",
          "This mesmerizing artwork takes you on a journey through automotive history, revisiting the iconic cars and classic beauties that once graced the roads. Each meticulously detailed brushstroke evokes the spirit of an era when craftsmanship and elegance defined the driving experience.",
        ],
        artwork_artist: "by Samuel, 14 years old, from Syria",
        artwork_more_from_artist: "more from Samuel",
        artwork_image: "/assets/images/artworks/car.webp",
        artwork_artist_id: "1",
        artwork_art_id: "8",
        ngo_id: "0",
        category: "Contemporary",
      },
      {
        artwork_heading: "Flowers of Warmth",
        artwork_subtitle: "Flowers beautifully rendered in vibrant warm colors",
        artwork_desc: [
          "Indulge in the radiant allure of 'Flowers of Warmth,' an enchanting artwork that blooms with a vivid array of colors. The artist's masterful strokes breathe life into these botanical wonders, immersing you in a world of vibrant warmth and beauty.",
          "Each petal and leaf dances with joyful hues, evoking a sense of serenity and filling the heart with the delightful embrace of nature's bountiful charm.",
        ],
        artwork_artist: "by Sara, 8 years old, from Syria",
        artwork_more_from_artist: "more from Sara",
        artwork_image: "/assets/images/artworks/colors_flowers.jpg",
        artwork_artist_id: "4",
        artwork_art_id: "9",
        ngo_id: "0",
        category: "Drawing",
      },
      {
        artwork_heading: "The Smarter Robot",
        artwork_subtitle: "Technology at its peak",
        artwork_desc: [
          "Enter the realm of 'The Smarter Robot,' a captivating artwork that showcases technology at its pinnacle. Witness the harmonious fusion of artistry and innovation as this extraordinary robot comes to life on canvas, embodying the cutting-edge brilliance that defines our modern age.",
          "With every brushstroke, the artist celebrates the marvels of progress, leaving you in awe of the boundless possibilities that lie ahead in the ever-evolving world of technology.",
        ],
        artwork_artist: "by Aarav, 10 years old, from Iran",
        artwork_more_from_artist: "more from Aarav",
        artwork_image: "/assets/images/artworks/robo.webp",
        artwork_artist_id: "3",
        artwork_art_id: "10",
        ngo_id: "1",
        category: "Other",
      },
      {
        artwork_heading: "A Different World",
        artwork_subtitle: "A different world, a different reality",
        artwork_desc: [
          "Embark on an extraordinary journey into 'A Different World,' where reality takes a captivating twist. This mesmerizing artwork defies convention, opening the door to a realm where imagination and creativity collide.",
          "Within its intricate details and dreamlike hues, a parallel universe awaits, urging you to explore the uncharted territories of possibility and wonder. ",
        ],
        artwork_artist: "by Hamid, 12 years old, from Afghanistan",
        artwork_more_from_artist: "more from Hamid",
        artwork_image: "/assets/images/artworks/abstract_2.jpg",
        artwork_artist_id: "2",
        artwork_art_id: "11",
        ngo_id: "2",
        category: "Abstract",
      },
    ],
    category_selection_heading: "Select a category",
    category_painting: "Painting",
    category_drawing: "Drawing",
    category_abstract: "Abstract",
    category_photography: "Photography",
    category_contemporary: "Contemporary",
    category_other: "Other",
  },
  // above in french
  fr: {
    title: "Explorer les œuvres d'art",
    subtitle:
      "Œuvres d'art inspirantes, créées par des enfants exceptionnels dans les situations les plus difficiles",
    featured_artwork_ids: [0, 1, 2],
    collection: [
      {
        artwork_heading: "Lien indéfectible",
        artwork_subtitle:
          "Un lien indéfectible entre une mère et son enfant représenté par l'utilisation de couleurs vives",
        artwork_desc: [
          "Présentation de 'Untethered Bond', une représentation fascinante d'une connexion indestructible entre une mère et son enfant. Des couleurs vives donnent vie à cette œuvre d'art captivante, évoquant l'essence profonde d'un lien inséparable.",
        ],
        artwork_artist: "par Nidhi, 10 ans, d'Inde",
        artwork_more_from_artist: "plus de Nidhi",
        artwork_image: "/assets/images/artworks/fox_art.jpg",
        artwork_artist_id: "0",
        artwork_art_id: "0",
        ngo_id: "1",
        category: "Drawing",
      },
      {
        artwork_heading: "Couleurs de la vie",
        artwork_subtitle:
          "Une représentation des couleurs de la vie et de la beauté de la nature",
        artwork_desc: [
          "Un portrait époustouflant d'un chat rendu dans une symphonie de tons vibrants, révélant les teintes diverses qui peignent la tapisserie de l'existence.",
          "Regardez dans les yeux captivants de cette muse féline alors qu'elle incarne les myriades de couleurs qui enrichissent notre voyage à travers la vie, créant une symphonie visuelle enchanteresse et harmonieuse. Laissez l'œuvre d'art vous emporter dans un royaume de couleur et de contemplation, où l'essence de la vie est magnifiquement capturée à travers cette représentation fascinante.",
        ],
        artwork_artist: "par Samuel, 14 ans, de Syrie",
        artwork_more_from_artist: "plus de Samuel",
        artwork_image: "/assets/images/artworks/cat_art.jpg",
        artwork_artist_id: "1",
        artwork_art_id: "1",
        ngo_id: "0",
        category: "Painting",
      },
      {
        artwork_heading: "Mains d'amour",
        artwork_subtitle:
          "L'espoir et l'amour peuvent vous aider à surmonter tous les obstacles de la vie",
        artwork_desc: [
          "Dans cette représentation émouvante, des mains délicates s'entrelacent gracieusement, symbolisant les liens indéfectibles formés par une affection et un encouragement sincères. Les coups de pinceau méticuleux et l'attention méticuleuse portée aux détails soulignent l'importance de chaque connexion que nous forgeons, que ce soit avec nos proches ou avec le monde qui nous entoure.",
          "\"Hands of Love\" est plus qu'une simple œuvre d'art; c'est un témoignage de l'esprit indomptable en chacun de nous. Laissez-vous captiver par son symbolisme profond et sa beauté tendre, et laissez son message résonner dans votre cœur, vous inspirant à embrasser le pouvoir de l'espoir et de l'amour dans votre propre parcours.",
        ],
        artwork_artist: "par Hamid, 12 ans, d'Afghanistan",
        artwork_more_from_artist: "plus de Hamid",
        artwork_image: "/assets/images/artworks/hands_art.jpg",
        artwork_artist_id: "2",
        artwork_art_id: "2",
        ngo_id: "2",
        category: "Painting",
      },
      {
        artwork_heading: "Blues du ciel",
        artwork_subtitle: "Espoir, ambition et rêves",
        artwork_desc: [
          "Plongez dans l'enchantement de \"Blues of the Sky\", où l'espoir, l'ambition et les rêves s'élèvent au milieu d'une toile céleste. Cette œuvre d'art captivante tisse une tapisserie d'aspirations, peinte avec des bleus éthérés qui enflamment l'imagination et remuent l'âme.",
          "Perdez-vous dans l'étendue sans limites des possibilités, alors que cette pièce sublime vous invite à embrasser le potentiel infini qui réside dans votre cœur.",
        ],
        artwork_artist: "par Aarav, 10 ans, d'Iran",
        artwork_more_from_artist: "plus de Aarav",
        artwork_image: "/assets/images/artworks/abstract_1.webp",
        artwork_artist_id: "3",
        artwork_art_id: "3",
        ngo_id: "1",
        category: "Abstract",
      },
      {
        artwork_heading: "Silence des montagnes",
        artwork_subtitle: "Niché dans le giron de la nature",
        artwork_desc: [
          "Un superbe portrait d'un paysage de montagne, niché dans le giron de la nature. L'artiste a utilisé une variété de couleurs pour dépeindre la beauté des montagnes et la sérénité de la nature environnante.",
          "Découvrez un chef-d'œuvre serein niché dans le giron de la nature. Laissez la beauté tranquille de cette œuvre d'art vous envelopper alors que vous parcourez les majestueux sommets, embrassant la profonde tranquillité qui résonne dans l'âme.",
        ],
        artwork_artist: "par Sara, 8 ans, de Syrie",
        artwork_more_from_artist: "plus de Sara",
        artwork_image: "/assets/images/artworks/mountain_art.jpg",
        artwork_artist_id: "4",
        artwork_art_id: "4",
        ngo_id: "0",
        category: "Contemporary",
      },
      {
        artwork_heading: "Graffiti de monstres",
        artwork_subtitle: "Un graffiti plein de monstres colorés",
        artwork_desc: [
          "Découvrez une explosion de couleurs et de créativité! Libérez votre imagination dans ce graffiti captivant, où un monde vibrant de surprises délicieuses vous attend.",
          "Explorez les profondeurs de cette création imaginative, où chaque coup de pinceau du pinceau de l'artiste révèle un nouveau et délicieux monstre qui attend d'être découvert.",
        ],
        artwork_artist: "par Samuel, 14 ans, de Syrie",
        artwork_more_from_artist: "plus de Samuel",
        artwork_image: "/assets/images/artworks/graffiti.jpg",
        artwork_artist_id: "1",
        artwork_art_id: "5",
        ngo_id: "0",
        category: "Other",
      },
      {
        artwork_heading: "Nuage de pensées",
        artwork_subtitle: "Une représentation des pensées de l'artiste",
        artwork_desc: [
          "Entrez dans un chef-d'œuvre introspectif qui dévoile les réflexions les plus intimes de l'artiste. Découvrez le monde énigmatique de l'imagination et de l'émotion, où les coups de génie convergent pour créer une tapisserie de pensées fascinante.",
        ],
        artwork_artist: "par Hamid, 12 ans, d'Afghanistan",
        artwork_more_from_artist: "plus de Hamid",
        artwork_image: "/assets/images/artworks/oil_painting.webp",
        artwork_artist_id: "2",
        artwork_art_id: "6",
        ngo_id: "2",
        category: "Painting",
      },
      {
        artwork_heading: "Togetherness",
        artwork_subtitle:
          "Dépeignant l'importance de la togetherness à travers les oiseaux",
        artwork_desc: [
          "Découvrez l'essence profonde de 'Togetherness', une œuvre d'art captivante qui capture magnifiquement l'importance de l'unité à travers des oiseaux gracieux en vol. Embarquez pour un voyage visuel qui célèbre le pouvoir de la camaraderie, s'élevant haut avec l'esprit harmonieux de la togetherness.",
        ],
        artwork_artist: "par Nidhi, 10 ans, d'Inde",
        artwork_more_from_artist: "plus de Nidhi",
        artwork_image: "/assets/images/artworks/birds.jpg",
        artwork_artist_id: "0",
        artwork_art_id: "7",
        ngo_id: "1",
        category: "Contemporary",
      },
      {
        artwork_heading: "Automobiles du passé",
        artwork_subtitle: "Revisiter les véhicules du passé",
        artwork_desc: [
          "Entrez dans une capsule temporelle nostalgique avec 'Automobiles of the Past', où l'art de véhicules d'antan revient à la vie.",
          "Cette œuvre d'art fascinante vous emmène dans un voyage à travers l'histoire de l'automobile, revisitant les voitures emblématiques et les beautés classiques qui ont autrefois orné les routes. Chaque coup de pinceau méticuleusement détaillé évoque l'esprit d'une époque où l'artisanat et l'élégance définissaient l'expérience de conduite.",
        ],
        artwork_artist: "par Samuel, 14 ans, de Syrie",
        artwork_more_from_artist: "plus de Samuel",
        artwork_image: "/assets/images/artworks/car.webp",
        artwork_artist_id: "1",
        artwork_art_id: "8",
        ngo_id: "0",
        category: "Contemporary",
      },
      {
        artwork_heading: "Fleurs de chaleur",
        artwork_subtitle:
          "Fleurs magnifiquement rendues dans des couleurs chaudes et vives",
        artwork_desc: [
          "Indulgez-vous dans l'allure rayonnante de 'Flowers of Warmth', une œuvre d'art enchanteresse qui fleurit avec une gamme vive de couleurs. Les coups de pinceau magistraux de l'artiste donnent vie à ces merveilles botaniques, vous plongeant dans un monde de chaleur et de beauté vibrantes.",
          "Chaque pétale et feuille danse avec des teintes joyeuses, évoquant un sentiment de sérénité et remplissant le cœur de l'étreinte délicieuse du charme abondant de la nature.",
        ],
        artwork_artist: "par Sara, 8 ans, de Syrie",
        artwork_more_from_artist: "plus de Sara",
        artwork_image: "/assets/images/artworks/colors_flowers.jpg",
        artwork_artist_id: "4",
        artwork_art_id: "9",
        ngo_id: "0",
        category: "Drawing",
      },
      {
        artwork_heading: "Le robot plus intelligent",
        artwork_subtitle: "La technologie à son apogée",
        artwork_desc: [
          "Entrez dans le royaume de 'The Smarter Robot', une œuvre d'art captivante qui présente la technologie à son apogée. Témoin de la fusion harmonieuse de l'art et de l'innovation alors que ce robot extraordinaire prend vie sur toile, incarnant l'éclat de pointe qui définit notre époque moderne.",
          "Avec chaque coup de pinceau, l'artiste célèbre les merveilles du progrès, vous laissant dans l'émerveillement des possibilités infinies qui se présentent dans le monde en constante évolution de la technologie.",
        ],
        artwork_artist: "par Aarav, 10 ans, d'Iran",
        artwork_more_from_artist: "plus de Aarav",
        artwork_image: "/assets/images/artworks/robo.webp",
        artwork_artist_id: "3",
        artwork_art_id: "10",
        ngo_id: "1",
        category: "Other",
      },
      {
        artwork_heading: "Un monde différent",
        artwork_subtitle: "Un monde différent, une réalité différente",
        artwork_desc: [
          "Embarquez pour un voyage extraordinaire dans 'Un monde différent', où la réalité prend une tournure captivante. Cette œuvre d'art fascinante défie la convention, ouvrant la porte à un royaume où l'imagination et la créativité entrent en collision.",
          "Dans ses détails complexes et ses teintes oniriques, un univers parallèle vous attend, vous exhortant à explorer les territoires inexplorés de la possibilité et de l'émerveillement.",
        ],
        artwork_artist: "par Hamid, 12 ans, d'Afghanistan",
        artwork_more_from_artist: "plus de Hamid",
        artwork_image: "/assets/images/artworks/abstract_2.jpg",
        artwork_artist_id: "2",
        artwork_art_id: "11",
        ngo_id: "2",
        category: "Abstract",
      },
    ],
    category_selection_heading: "Sélectionnez une catégorie",
    category_painting: "Peinture",
    category_drawing: "Dessin",
    category_abstract: "Abstrait",
    category_photography: "Photographie",
    category_contemporary: "Contemporain",
    category_other: "Autre",
  },
};

export default artwork_data;
